import type { StateType } from '../../reducers';
import type { BundleStateType } from './reducer';
import { selectedRoamingPackageZoneSelector } from '../../International/Roaming/reducer';
import { roamingPackageUsagesSelector } from '../../Usage/selectors';
import { isExemptedFromTaxSelector } from '../../Customer/selectors';
import { canChangePlanOrOptionsOfCurrentSubscriptionSelector } from '../../Dashboard';
import { RoamingPackage } from 'digicel-kaizen-library';

const bundleStateSelector = (state: StateType): BundleStateType => state.topUps.bundle;

const roamingBundlesSelector = (state: StateType): RoamingPackage[][] => {
  const bundleState = bundleStateSelector(state);
  return bundleState.roaming && Object.values(bundleState.roaming);
};

export const selectedRoamingPackageSelector = state => {
  const roamingBundles = roamingBundlesSelector(state);
  const zone = selectedRoamingPackageZoneSelector(state, true);
  return (
    roamingBundles &&
    roamingBundles.find((roamingBundle: RoamingPackage[]) => {
      const { name } = roamingBundle[0];

      if (zone === 'EXTENDED_ROAM_LIKE_HOME') {
        return name.includes('RLH2');
      } else if (zone === 'ROAM_LIKE_HOME') {
        return name.includes('RLH') && !name.includes('RLH2');
      }

      const splitName = name.split('G');
      const topupZone = splitName[splitName.length - 1];
      return topupZone && topupZone == zone;
    })[0]
  );
};

export const selectedRoamingPackagePriceSelector = state => {
  const roamingBundlesGroup = selectedRoamingPackageSelector(state);
  const priceKey = isExemptedFromTaxSelector(state) ? 'dutyFreeAmount' : 'taxIncludedAmount';
  return roamingBundlesGroup && roamingBundlesGroup.price && roamingBundlesGroup.price[priceKey];
};

const selectedRoamingPackageUsagesSelector = state => {
  const selectedZone = selectedRoamingPackageZoneSelector(state, true);
  const roamingUsages = roamingPackageUsagesSelector(state);
  return roamingUsages.filter(usage => usage.zone === selectedZone);
};

export const canBuySelectedRoamingPackageSelector = (state: StateType) => {
  if (!canChangePlanOrOptionsOfCurrentSubscriptionSelector(state)) return false;
  if (selectedRoamingPackagePriceSelector(state) == null) return false;

  const selectedUsages = selectedRoamingPackageUsagesSelector(state);
  return !selectedUsages.find(usage => {
    const isAnyRLH = usage.zone === 'ROAM_LIKE_HOME' || usage.zone === 'EXTENDED_ROAM_LIKE_HOME';
    return (
      usage.status === 'PENDING_ROAMING' ||
      (usage.status === 'ROAMING' && isAnyRLH) ||
      (!isAnyRLH && usage.totalRoamingPacks >= 2)
    );
  });
};
